/* eslint-disable comma-dangle */
/* eslint-disable quotes */
import * as firebase from "firebase/app";
import "firebase/firestore";
import constants from "../constants";
import Reservation from "../models/reservation.model";
import AuthService from "../services/auth.service";
import User from "../models/user.model";

if (firebase.apps && firebase.apps.length === 0) {
  firebase.initializeApp(constants.firebaseConfig);
}

export default class ReservationsService {
  /**
   *
   * @param {{
   *  type: string,
   *  user: User,
   *  community: Community,
   *  date: Date,
   *  estimatedExit: Date
   * }} formData
   */
  static async makeReservation(formData) {
    if (!formData.user) {
      formData.user = await AuthService.getCurrentUser();
    }
    try {
      if (!formData.parking) {
        formData.parking = await formData.community.pickOneAvailableParking();
      }
    } catch (e) {
      throw new Error(`Error buscando estacionamiento disponible: ${e}`);
    }
    if (!formData.parking) {
      throw new Error("Esta comunidad no tiene estacionamientos disponibles");
    }
    const hydration = await Reservation.buildHydrationForCreation(formData);
    const reservation = new Reservation();
    const {
      type,
      reservedBy,
      user,
      parking,
      createdAt,
      date,
      estimatedExit,
      vehicle,
      status,
      logs
    } = hydration;
    reservation.hydrate(hydration);
    const data = {
      type,
      reservedBy: reservedBy.selfRef,
      user: user.selfRef,
      parking: parking.selfRef,
      createdAt,
      date,
      estimatedExit,
      vehicle,
      status,
      logs
    };
    const db = firebase.firestore();
    const firebaseReservation = await db
      .collection(constants.collections.reservations)
      .add(data);
    reservation._selfRef = firebaseReservation;
    return reservation;
  }

  static async sendInvitation(formData) {
    const authCreator = firebase.auth().currentUser;
    const db = firebase.firestore();
    const creatorRef = db
          .collection(constants.collections.profiles)
          .doc(authCreator.uid);
    const creatorSnapshot = await creatorRef.get();
    const creator = creatorSnapshot.exists ? creatorSnapshot.data() : undefined;
    if (!creator || (creator && creator.role !== constants.roles.PARTNER)) {
      throw new Error(
        "Cannot send invitation if there's no partner user logged in."
      );
    }
    const currentUser = new User(authCreator, creator).toSubClass();
    let receiver;
    try {
      receiver = await User.findUserByRut(formData.rut);
    } catch (e) {
      console.log("Error looking user up", e);
      throw new Error(e);
    }
    if (!receiver) {
      throw new Error("Receiver user does not exist");
    }
    let chosenParking;
    let community = await currentUser.getCommunity();
    if (formData.useCommunityParking) {
      try {
        chosenParking = await community.pickOneAvailableVisitorsParking();
      } catch (e) {
        console.log('Error', e);
        throw new Error("Error buscando estacionamiento de visitas disponible");
      }
    } else {
      try {
        chosenParking = await currentUser.getFirstAvailableParking();
        chosenParking.selfRef.update({ available: false });
      } catch (e) {
        console.log('Error', e);
        throw new Error("Error buscando estacionamiento disponible");
      }
    }
    if (!chosenParking) {
      throw new Error("No hay estacionamientos disponibles");
    }
    const params = {
      type: 'invitation',
      user: db.collection(constants.collections.profiles).doc(receiver.uid),
      community,
      parking: chosenParking,
      date: formData.startTime.toDate(),
      estimatedExit: formData.endTime.toDate()
    };
    const hydration = await Reservation.buildHydrationForCreation(params);
    const reservation = new Reservation();
    const {
      type,
      reservedBy,
      user,
      parking,
      createdAt,
      date,
      estimatedExit,
      vehicle,
      status,
      logs
    } = hydration;
    reservation.hydrate(hydration);
    const data = {
      type,
      reservedBy: reservedBy.selfRef,
      user,
      parking: parking.selfRef,
      createdAt,
      date,
      estimatedExit,
      vehicle,
      status,
      logs
    };
    let firebaseReservation;
    try {
      firebaseReservation = await db
      .collection(constants.collections.reservations)
      .add(data);
    } catch (e) {
      console.log("Error:", e);
      throw new Error("Error al crear la reserva");
    }
    reservation._selfRef = firebaseReservation;
    return reservation;
  }
}
